// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods_detail .goods_detail_wrapper[data-v-c8b6bfc6] {\n  z-index: 200;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 375px;\n  background: #f0f2f5;\n}\n.goods_detail .goods_detail_wrapper.on[data-v-c8b6bfc6] {\n  position: fixed;\n}", ""]);
// Exports
module.exports = exports;
